export const MINISTRYSHOW_MODAL = "MINISTRYSHOW_MODAL";
export const MINISTRYCLOSE_MODAL = "MINISTRYCLOSE_MODAL";

export const ModalTypes = {
  MINISTRYSHOW_DOCUMENT: "MINISTRYSHOW_DOCUMENT",
};

export function processModal(actionType, modalType, modalProps) {
  return {
    type: actionType,
    modal: {
      modalType: modalType,
      modalProps: modalProps,
    },
  };
}

export function closeModal(payload) {
  return { type: MINISTRYCLOSE_MODAL };
}
